import script from "./FacultiesCards.vue?vue&type=script&setup=true&lang=js"
export * from "./FacultiesCards.vue?vue&type=script&setup=true&lang=js"

import "./FacultiesCards.vue?vue&type=style&index=0&id=20da727b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20da727b"]])

export default __exports__